module.exports = __webpack_public_path__ + "img/horizontal_3_4_3.e1bfa714.png";